<ng-template #customerDetailsRef let-modal>
	<div class="modal-header">
		<h4 class="modal-title" id="modal-title">Customer Details</h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')">
			<i class="fa fa-close"></i>
		</button>
	</div>
	<div class="modal-body text-dark">
		<div class="table-responsive">
			<table class="table table-fixed table-striped table-hover w-100" *ngIf="customerdetails?.length">
				<thead class="thead-dark sticky-header">
					<tr>
						<th>Date</th>
						<th>Item</th>
						<th>Desc</th>
						<th>Qty</th>
						<th>Price</th>
						<th>Total</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let i of customerdetails">
						<td>{{ i.date_added }}</td>
						<td>{{ i.stockid }}</td>
						<td>{{ i.name }}</td>
						<td>{{ i.quantity }}</td>
						<td>{{ i.price | currency }}</td>
						<td>{{ i.price * i.quantity | currency }}</td>
					</tr>
				</tbody>
			</table>
			<h4 class="text-center mt-3" *ngIf="!customerdetails?.length">No Records Found</h4>
		</div>
	</div>
	<div class="modal-footer"></div>
</ng-template>

<div class="tc-wrap" [ngStyle]="themeVars">

	<div class="tc-icon-badge">
		<i class="material-icons">emoji_events</i>
	</div>

	<div class="tc-header">
		<div class="tc-title-group">
			<span class="tc-title">{{ title }}</span>
			<span class="tc-subtitle">{{ getReportDateRangeCaption() }}</span>
		</div>
		<div class="tc-actions">
			<button class="tc-preset-toggle" type="button" [class.tc-preset-toggle--active]="showPresets"
					(click)="showPresets = !showPresets" title="Change period">
				<i class="material-icons">date_range</i>
				{{ activePreset || 'Period' }}
				<i class="material-icons tc-chevron">expand_more</i>
			</button>
			<button class="tc-icon-btn" type="button" (click)="reloadCustomers()" [disabled]="loading" title="Refresh">
				<i class="material-icons">refresh</i>
			</button>
			<button class="tc-icon-btn" type="button" (click)="exportXls()" [disabled]="loading || (!splitBySalesrep && !(viewing?.length))" title="Export Excel">
				<i class="fa fa-file-excel-o"></i>
			</button>
			<button class="tc-icon-btn" type="button" (click)="exportPdf()" [disabled]="loading" title="Export PDF">
				<i class="fa fa-file-pdf-o"></i>
			</button>
			<button class="tc-icon-btn" type="button" [class.tc-icon-btn--active]="showFilters || filterCount > 0" (click)="showFilters = !showFilters" title="Filters">
				<i class="material-icons">tune</i>
				<span class="tc-filter-count" *ngIf="filterCount > 0">{{ filterCount }}</span>
			</button>
			<button class="tc-icon-btn"
					type="button"
					[class.tc-icon-btn--active]="flip === 'active'"
					(click)="toggleFlip(topcustomers, title)"
					[disabled]="loading"
					[title]="flip === 'active' ? 'Collapse details' : 'View details'">
				<i class="material-icons">{{ flip === 'active' ? 'expand_less' : 'expand_more' }}</i>
			</button>
		</div>
	</div>

	<!-- Period presets — identical behavior to the Sales Team card -->
	<div class="tc-presets" *ngIf="showPresets">
		<button *ngFor="let p of presets" type="button"
				class="tc-preset-btn" [class.tc-preset-btn--active]="activePreset === p.label"
				(click)="selectPreset(p)">{{ p.label }}</button>

		<div class="tc-custom-range" *ngIf="activePreset === 'Custom'">
			<input type="date" class="tc-date-input" [(ngModel)]="customFrom" [max]="customTo || null">
			<span class="tc-custom-sep">to</span>
			<input type="date" class="tc-date-input" [(ngModel)]="customTo" [min]="customFrom || null">
			<button class="tc-apply-btn" type="button" (click)="applyCustom()" [disabled]="loading || !customFrom || !customTo">
				<i class="material-icons">play_arrow</i> Go
			</button>
		</div>
	</div>

	<!-- Filters live at card level, not inside the flipped detail view, so the
	     tune button works the same whether the card is collapsed or expanded. -->
	<form [formGroup]="searchForm" class="tc-filters" *ngIf="showFilters">
		<mat-form-field appearance="outline" class="tc-field tc-field--narrow">
			<mat-label>Limit</mat-label>
			<input matInput type="number" formControlName="limit" min="1" [max]="topCustomersMaxLimit" />
		</mat-form-field>

		<mat-form-field appearance="outline" class="tc-field">
			<mat-label>Locations</mat-label>
			<mat-select formControlName="loccode" multiple appSelectAll>
				<mat-option *ngFor="let l of locations" [value]="l.loccode">{{ l.locationname || l.loccode }}</mat-option>
			</mat-select>
		</mat-form-field>

		<mat-form-field *ngIf="!issalesman" appearance="outline" class="tc-field">
			<mat-label>Salespeople</mat-label>
			<mat-select formControlName="salesperson" multiple appSelectAll>
				<mat-option *ngFor="let sp of salespeople" [value]="sp.salesmancode">{{ sp.salesmanname }}</mat-option>
			</mat-select>
		</mat-form-field>

		<mat-form-field appearance="outline" class="tc-field">
			<mat-label>Brands</mat-label>
			<mat-select formControlName="brand" multiple appSelectAll>
				<mat-option *ngFor="let v of brands" [value]="v.manufacturer_id">{{ v.name }}</mat-option>
			</mat-select>
		</mat-form-field>

		<mat-form-field appearance="outline" class="tc-field">
			<mat-label>Categories</mat-label>
			<mat-select formControlName="category" multiple appSelectAll>
				<mat-option *ngFor="let v of categories" [value]="v.categoryid">{{ v.categoryid }} — {{ v.categorydescription }}</mat-option>
			</mat-select>
		</mat-form-field>

		<mat-form-field appearance="outline" class="tc-field">
			<mat-label>Product lines</mat-label>
			<mat-select formControlName="prodline" multiple appSelectAll>
				<mat-option *ngFor="let v of productlines" [value]="v.line_field">{{ v.line_description }}</mat-option>
			</mat-select>
		</mat-form-field>

		<div class="tc-filter-actions">
			<button class="tc-apply-btn" type="button" (click)="applyFilters()" [disabled]="loading">
				<i class="material-icons">play_arrow</i> Apply
			</button>
			<button class="tc-clear-btn" type="button" (click)="clearFilters()" [disabled]="loading || filterCount === 0">
				<i class="material-icons">clear</i> Clear
			</button>
		</div>
	</form>

	<div class="tc-stats" *ngIf="!loading">
		<div class="tc-stat">
			<span class="tc-stat-val">{{ cardResultCount }}</span>
			<span class="tc-stat-lbl">Customers</span>
		</div>
		<div class="tc-stat">
			<span class="tc-stat-val">{{ globalTotalSales | currency }}</span>
			<span class="tc-stat-lbl">Total Sales</span>
		</div>
		<div class="tc-stat" *ngIf="flip === 'active'">
			<span class="tc-stat-val">{{ globalTotalUnits | number }}</span>
			<span class="tc-stat-lbl">Units</span>
		</div>
		<div class="tc-stat" *ngIf="flip === 'active'">
			<span class="tc-stat-val">{{ globalTotalDeliveries | number }}</span>
			<span class="tc-stat-lbl">Orders</span>
		</div>
		<div class="tc-stat" *ngIf="flip === 'active'">
			<span class="tc-stat-val">{{ globalAvgDelivery | currency }}</span>
			<span class="tc-stat-lbl">Avg Order</span>
		</div>
		<div class="tc-stat tc-stat--wide">
			<span class="tc-stat-val">{{ getReportDateRangeCaption() }}</span>
			<span class="tc-stat-lbl">Period</span>
		</div>
	</div>

	<div class="tc-loading" *ngIf="loading">
		<svg class="spinner" width="40" height="40" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
			<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
		</svg>
	</div>

	<div class="tc-view-row" *ngIf="flip !== 'active' && !loading">
		<button class="tc-view-btn" type="button" (click)="toggleFlip(topcustomers, title)">
			<i class="material-icons">table_rows</i>
			<span>View Details</span>
		</button>
	</div>

	<div class="tc-detail" *ngIf="flip === 'active' && !loading">

		<div class="tc-body">
			<p class="tc-hint" *ngIf="(splitBySalesrep && perRepResults?.length) || (!splitBySalesrep && viewing?.length)">
				Ranked by invoiced sales in range · Limit {{ reportLimit }}<span *ngIf="splitBySalesrep"> · one tab per salesperson</span>
			</p>

			<div class="tc-empty" *ngIf="!splitBySalesrep && (!viewing || viewing.length === 0)">No customers match the current filters.</div>
			<div class="tc-empty" *ngIf="splitBySalesrep && (!perRepResults?.length || !perRepResultsHasAnyRows)">No customers match the current filters.</div>

			<mat-tab-group *ngIf="splitBySalesrep && perRepResults?.length" class="tc-rep-tabs" animationDuration="0ms">
				<mat-tab *ngFor="let seg of perRepResults" [label]="seg.salesmanname + ' (' + (seg.customers?.length || 0) + ')'">
					<div class="tc-list tc-list--tab" *ngIf="seg.customers?.length">
						<div class="tc-list-header">
							<span class="tc-col-rank">#</span>
							<span class="tc-col-name">Name</span>
							<span class="tc-col-contact">Contact</span>
							<span class="tc-col-phone">Phone</span>
							<span class="tc-col-email">Email</span>
							<span class="tc-col-last">Last Seen</span>
							<span class="tc-col-sales text-end">Sales</span>
							<span class="tc-col-units text-end">Units</span>
							<span class="tc-col-deliv text-end">Orders</span>
							<span class="tc-col-avgdeliv text-end">Avg Order</span>
						</div>
						<div class="tc-row" *ngFor="let d of seg.customers; let i = index">
							<span class="tc-col-rank">
								<span class="tc-rank-badge" [ngClass]="{'tc-rank-gold': i === 0, 'tc-rank-silver': i === 1, 'tc-rank-bronze': i === 2}">
									{{ i + 1 }}
								</span>
							</span>
							<span class="tc-col-name">
								<a [routerLink]="['/customers/view/', d.debtorno]" class="tc-customer-name">
									{{ d.name || d.deliverto }}
								</a>
								<span class="tc-customer-id">{{ d.debtorno }}.{{ d.branchcode }}</span>
							</span>
							<span class="tc-col-contact">{{ d.contactname || '—' }}</span>
							<span class="tc-col-phone">{{ d.phoneno || '—' }}</span>
							<span class="tc-col-email">
								<a *ngIf="d.email" [href]="'mailto:' + d.email" class="tc-email-link" [title]="d.email">{{ d.email }}</a>
								<span *ngIf="!d.email">—</span>
							</span>
							<span class="tc-col-last">{{ d.lastseen || '—' }}</span>
							<span class="tc-col-sales text-end">
								<strong>{{ d.salestotal | currency }}</strong>
							</span>
							<span class="tc-col-units text-end">{{ d.qtytotal | number }}</span>
							<span class="tc-col-deliv text-end">{{ d.deliverycount | number }}</span>
							<span class="tc-col-avgdeliv text-end">{{ d.avgdelivery | currency }}</span>
						</div>
					</div>
					<div class="tc-empty" *ngIf="!seg.customers?.length">No customers for this salesperson in the selected range.</div>
				</mat-tab>
			</mat-tab-group>

			<div class="tc-list" *ngIf="!splitBySalesrep && viewing?.length">
				<div class="tc-list-header">
					<span class="tc-col-rank">#</span>
					<span class="tc-col-name">Name</span>
					<span class="tc-col-contact">Contact</span>
					<span class="tc-col-phone">Phone</span>
					<span class="tc-col-email">Email</span>
					<span class="tc-col-last">Last Seen</span>
					<span class="tc-col-sales text-end">Sales</span>
					<span class="tc-col-units text-end">Units</span>
					<span class="tc-col-deliv text-end">Orders</span>
					<span class="tc-col-avgdeliv text-end">Avg Order</span>
				</div>

				<div class="tc-row" *ngFor="let d of viewing; let i = index">
					<span class="tc-col-rank">
						<span class="tc-rank-badge" [ngClass]="{'tc-rank-gold': i === 0, 'tc-rank-silver': i === 1, 'tc-rank-bronze': i === 2}">
							{{ i + 1 }}
						</span>
					</span>

					<span class="tc-col-name">
						<a [routerLink]="['/customers/view/', d.debtorno]" class="tc-customer-name">
							{{ d.name || d.deliverto }}
						</a>
						<span class="tc-customer-id">{{ d.debtorno }}.{{ d.branchcode }}</span>
					</span>

					<span class="tc-col-contact">{{ d.contactname || '—' }}</span>
					<span class="tc-col-phone">{{ d.phoneno || '—' }}</span>

					<span class="tc-col-email">
						<a *ngIf="d.email" [href]="'mailto:' + d.email" class="tc-email-link" [title]="d.email">{{ d.email }}</a>
						<span *ngIf="!d.email">—</span>
					</span>

					<span class="tc-col-last">{{ d.lastseen || '—' }}</span>

					<span class="tc-col-sales text-end">
						<strong>{{ d.salestotal | currency }}</strong>
					</span>

					<span class="tc-col-units text-end">{{ d.qtytotal | number }}</span>
					<span class="tc-col-deliv text-end">{{ d.deliverycount | number }}</span>
					<span class="tc-col-avgdeliv text-end">{{ d.avgdelivery | currency }}</span>
				</div>
			</div>
		</div>
	</div>
</div>
